import { render, staticRenderFns } from "./ednMail.vue?vue&type=template&id=56e805dd"
import script from "./ednMail.vue?vue&type=script&lang=js"
export * from "./ednMail.vue?vue&type=script&lang=js"
import style0 from "./ednMail.vue?vue&type=style&index=0&id=56e805dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports